import { post } from './apiClient';

export function submitEventLead(lead) {
  return post('/event-lead', lead);
}